<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic pricing-panel">
      <div class="pricing-title">HOURLY RENTAL</div>
      <p class="pricing-note">
        (all boats prorated at $20 per hour beyond the first hour)
      </p>
      <div class="rate-table">
        <div class="rate-row"><strong>Canoe</strong><span>$30</span></div>
        <div class="rate-row">
          <strong>Single Kayak</strong><span>$25</span>
        </div>
        <div class="rate-row">
          <strong>Tandem Kayak</strong><span>$35</span>
        </div>
        <div class="rate-row">
          <strong>Row Boat</strong><span>$30 (Busse and Tampier only)</span>
        </div>
        <div class="rate-row">
          <strong>Fishing boat (with battery and trolling motor)</strong>
          <span>$30 per hour, 2-hour minimum (Busse and Tampier only)</span>
        </div>
        <div class="rate-row">
          <strong>Monday Discount</strong>
          <span>Reduced first-hour rates (except public holidays)</span>
        </div>
        <div class="rate-row"><strong>Canoe</strong><span>$25</span></div>
        <div class="rate-row">
          <strong>Single Kayak</strong><span>$20</span>
        </div>
        <div class="rate-row">
          <strong>Tandem Kayak</strong><span>$30</span>
        </div>
        <div class="rate-row"><strong>Row Boat</strong><span>$25</span></div>
        <div class="rate-row">
          <strong>Fishing boat (with battery and trolling motor)</strong>
          <span>$50 two-hour minimum; then prorated at $20/hour</span>
        </div>
        <div class="rate-row">
          <strong>Paddle Card</strong>
          <span
            >Fifth visit FREE after four paid visits (some restrictions
            apply)</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pricing",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.red {
  color: red;
}

.pricing-note {
  text-align: center;
}

.page {
  background-image: url("../assets/pic4.jpg");
  flex-direction: column;
}
.page .pricing-panel {
  box-sizing: border-box;
  width: min(650px, calc(100vw - 20px));
  max-width: none;
  font-weight: normal;
}
.pricing-title {
  margin-bottom: 18px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
}
.pricing-note {
  margin-bottom: 16px;
}
.rate-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: 12px;
  align-items: start;
  padding: 8px 0;
  border-bottom: 1px solid #999;
  font-size: 16px;
  line-height: 1.5;
}
.rate-row span {
  text-align: right;
}
@media screen and (max-width: 480px) {
  .rate-row {
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 8px;
  }
}
</style>
